module.exports = __webpack_public_path__ + "img/prusik.43ec60fb.jpg";